export default {"src":"/_next/static/media/women-icon.2e297e90.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};